import dayjs from 'dayjs';

import { DatePickerProps } from 'shared/ui';

export const customFormat: DatePickerProps['format'] = (value) =>
  `${dayjs(value).locale('ru').format('DD MMM YYYY')}`;
